import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initializeSwiper() {
  const heroSettings = {
    direction: 'horizontal',
    slidesPerView: '1',
    spaceBetween: 0,
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: true,
    lazy: {
      loadPrevNext: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  const relatedModelsSettings = {
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: false,
    lazy: {
      loadPrevNext: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1920: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      2560: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  };
  const relatedOffersSettings = {
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: false,
    lazy: {
      loadPrevNext: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1920: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      2560: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  };
  const relatedLocationsSettings = {
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: false,
    lazy: {
      loadPrevNext: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1920: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      2560: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  };
  const featuredOffersSettings = {
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: false,
    lazy: {
      loadPrevNext: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 28,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
      1920: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
      2560: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
    },
  };
  const featuredModelsSettings = {
    direction: 'horizontal',
    grabCursor: true,
    loop: false,
    preloadImages: false,
    lazyLoading: false,
    lazy: {
      loadPrevNext: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 28,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
      1920: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
      2560: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
    },
  };
  const modelSliderThumbsSettings = new Swiper('.model-slider-thumbs', {
    spaceBetween: 1,
    direction: 'horizontal',
    preloadImages: false,
    lazyLoading: true,
    lazy: {
      loadPrevNext: true,
    },
    allowTouchMove: true,
    slidesPerView: 4,
    freeMode: true,
    grabCursor: true,
    speed: 250,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 3,
      },
      1536: {
        slidesPerView: 4,
      },
      1920: {
        slidesPerView: 4,
      },
      2560: {
        slidesPerView: 6,
      },
    },
  });
  const modelSliderSettings = new Swiper('.model-slider', {
    autoplay: false,
    direction: 'horizontal',
    allowTouchMove: true,
    slidesPerView: '1',
    grabCursor: true,
    spaceBetween: 0,
    keyboardControl: true,
    speed: 800,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet lr-bg-swiper_pagination_dot lr-mx-1 lg:lr-mx-2 lr-w-2 lr-h-2',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: modelSliderThumbsSettings,
      slideThumbActiveClass: 'lr-opacity-50',
    },
  });
  // Grab a reference to the media query.
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // if the user asked for no anmiations:
  if (!mediaQuery || mediaQuery.matches) {
    //Hero
    heroSettings.effect = 'fade';
    heroSettings.speed = 0;
    heroSettings.autoplay = false;
    //Models
    modelSliderSettings.effect = 'slide';
    modelSliderSettings.speed = 1200;
    modelSliderSettings.autoplay = false;
    //Related Models
    relatedModelsSettings.effect = 'slide';
    relatedModelsSettings.speed = 1200;
    relatedModelsSettings.autoplay = false;
    //Related Offers
    relatedOffersSettings.effect = 'slide';
    relatedOffersSettings.speed = 1200;
    relatedOffersSettings.autoplay = false;
    //Related Locations
    relatedLocationsSettings.effect = 'slide';
    relatedLocationsSettings.speed = 1200;
    relatedLocationsSettings.autoplay = false;
    //Featured Offers
    featuredOffersSettings.effect = 'slide';
    featuredOffersSettings.speed = 1200;
    featuredOffersSettings.autoplay = false;
    //Featured Models
    featuredModelsSettings.effect = 'slide';
    featuredModelsSettings.speed = 1200;
    featuredModelsSettings.autoplay = false;
  } else {
    heroSettings.effect = 'slide';
    heroSettings.speed = 800;
    heroSettings.autoplay = false;
    modelSliderSettings.effect = 'slide';
    modelSliderSettings.speed = 900;
    modelSliderSettings.autoplay = false;
    relatedModelsSettings.effect = 'slide';
    relatedModelsSettings.speed = 900;
    relatedModelsSettings.autoplay = false;
    relatedOffersSettings.effect = 'slide';
    relatedOffersSettings.speed = 900;
    relatedOffersSettings.autoplay = false;
    //Related Locations
    relatedLocationsSettings.effect = 'slide';
    relatedLocationsSettings.speed = 900;
    relatedLocationsSettings.autoplay = false;
    //Featured Offers
    featuredOffersSettings.effect = 'slide';
    featuredOffersSettings.speed = 900;
    featuredOffersSettings.autoplay = false;
    //Featured Models
    featuredModelsSettings.effect = 'slide';
    featuredModelsSettings.speed = 900;
    featuredModelsSettings.autoplay = false;
  }

  // Initialize the slider with the correct settings
  if (document.getElementById('hero-slider')) {
    let heroSlider = new Swiper('.hero-slider', heroSettings);
  }
  if (document.getElementById('model-slider')) {
    let modelsSlider = new Swiper('.model-slider', modelSliderSettings);
  }
  if (document.getElementById('model-slider-thumbs')) {
    let modelSliderThumnbs = new Swiper('.model-slider-thumbs', modelSliderThumbsSettings);
  }
  if (document.getElementById('related-offers-slider')) {
    let relatedOffersSlider = new Swiper('.related-offers-slider', relatedOffersSettings);
  }
  if (document.getElementById('related-models-slider')) {
    let relatedModelsSlider = new Swiper('.related-models-slider', relatedModelsSettings);
  }
  if (document.getElementById('related-locations-slider')) {
    let relatedLocationsSlider = new Swiper('.related-locations-slider', relatedLocationsSettings);
  }
  if (document.getElementById('featured-offers-slider')) {
    let featuredOffersSlider = new Swiper('.featured-offers-slider', featuredOffersSettings);
  }
  if (document.getElementById('featured-models-slider')) {
    let featuredModelsSlider = new Swiper('.featured-models-slider', featuredModelsSettings);
  }
  // Listen for changes in the media query.
  mediaQuery.addEventListener('change', () => {
    // Unset the slider instance.
    heroSlider.destroy();
    modelsSlider.destroy();
    relatedModelsSlider.destroy();

    // if the user asked for no anmiations.
    if (mediaQuery.matches) {
      //Hero
      heroSettings.effect = 'fade';
      heroSettings.speed = 0;
      heroSettings.autoplay = false;
      //Brand - Multiple Models
      gallerySliderSettings.effect = 'slide';
      gallerySliderSettings.speed = 1200;
      gallerySliderSettings.autoplay = false;
      //Related Models
      relatedModelsSettings.effect = 'slide';
      relatedModelsSettings.speed = 1200;
      relatedModelsSettings.autoplay = false;
      //Related Offers
      relatedOffersSettings.effect = 'slide';
      relatedOffersSettings.speed = 1200;
      relatedOffersSettings.autoplay = false;
      //Related Locations
      relatedLocationsSettings.effect = 'slide';
      relatedLocationsSettings.speed = 1200;
      relatedLocationsSettings.autoplay = false;
      //Featured Offers
      featuredOffersSettings.effect = 'slide';
      featuredOffersSettings.speed = 1200;
      featuredOffersSettings.autoplay = false;
      //Featured Models
      featuredModelsSettings.effect = 'slide';
      featuredModelsSettings.speed = 1200;
      featuredModelsSettings.autoplay = false;
    } else {
      heroSettings.effect = 'slide';
      heroSettings.speed = 800;
      heroSettings.autoplay = false;
      gallerySliderSettings.effect = 'slide';
      gallerySliderSettings.speed = 900;
      gallerySliderSettings.autoplay = false;
      relatedModelsSettings.effect = 'slide';
      relatedModelsSettings.speed = 900;
      relatedModelsSettings.autoplay = false;
      relatedOffersSettings.effect = 'slide';
      relatedOffersSettings.speed = 900;
      relatedOffersSettings.autoplay = false;
      //Related Locations
      relatedLocationsSettings.effect = 'slide';
      relatedLocationsSettings.speed = 900;
      relatedLocationsSettings.autoplay = false;
      //Featured Offers
      featuredOffersSettings.effect = 'slide';
      featuredOffersSettings.speed = 900;
      featuredOffersSettings.autoplay = false;
      //Featured Models
      featuredModelsSettings.effect = 'slide';
      featuredModelsSettings.speed = 900;
      featuredModelsSettings.autoplay = false;
    }
    // re-initialize the slider with the correct settings.
    if (document.getElementById('hero-slider')) {
      heroSlider = new Swiper('.hero-slider', heroSettings);
    }
    if (document.getElementById('model-slider')) {
      modelsSlider = new Swiper('.model-slider', modelSliderSettings);
    }
    if (document.getElementById('model-slider-thumbs')) {
      modelSliderThumnbs = new Swiper('.model-slider-thumbs', modelSliderThumbsSettings);
    }
    if (document.getElementById('related-models-slider')) {
      relatedModelsSlider = new Swiper('.related-models-slider', relatedModelsSettings);
    }
    if (document.getElementById('related-offers-slider')) {
      relatedOffersSlider = new Swiper('.related-offers-slider', relatedOffersSettings);
    }
    if (document.getElementById('related-locations-slider')) {
      relatedLocationsSlider = new Swiper('.related-locations-slider', relatedLocationsSettings);
    }
    if (document.getElementById('featured-offers-slider')) {
      featuredOffersSlider = new Swiper('.featured-offers-slider', featuredOffersSettings);
    }
    if (document.getElementById('featured-models-slider')) {
      featuredModelsSlider = new Swiper('.featured-models-slider', featuredModelsSettings);
    }
  });
}
